var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.unpaid && _vm.unpaid !== "paid"
    ? _c(
        "div",
        {
          staticClass: "state-warning unpaid",
          class: { "state-error": _vm.unpaid === "locked" }
        },
        [
          _c("p", [
            _vm._v(_vm._s(_vm._f("trans")("billings:invoices.unpaid")))
          ]),
          _vm._v(" "),
          _vm.unpaid === "locked"
            ? _c("p", [
                _vm._v(
                  _vm._s(_vm._f("trans")("billings:invoices.unpaid_locked"))
                )
              ])
            : _c("p", [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")("billings:invoices.unpaid_remain", {
                      days: _vm.unpaid
                    })
                  )
                )
              ]),
          _vm._v(" "),
          _vm.link
            ? _c(
                "router-link",
                {
                  staticClass: "btn",
                  attrs: { to: { name: _vm.target_path } }
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(_vm._f("trans")("billings:invoices.view")) +
                      "\n  "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25936542", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25936542","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/billings/components/Unpaid.vue
// module id = null
// module chunks = 